export default __webpack_public_path__ + "static/media/logoM.30b48d41.svg";